import EditExpiringPolicy from './EditExpiringPolicy';

export default EditExpiringPolicy;
